import "./accordion.scss";

document.addEventListener("DOMContentLoaded", function () {
  const accordionButtons = document.querySelectorAll(".accordion__button");

  accordionButtons.forEach((button, index) => {
    button.addEventListener("click", function () {
      toggleAccordion(this);
    });

    // Tastatur-Navigation mit Pfeiltasten
    button.addEventListener("keydown", function (e) {
      let target = null;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          target = accordionButtons[index + 1] || accordionButtons[0];
          break;
        case "ArrowUp":
          e.preventDefault();
          target =
            accordionButtons[index - 1] ||
            accordionButtons[accordionButtons.length - 1];
          break;
        case "Home":
          e.preventDefault();
          target = accordionButtons[0];
          break;
        case "End":
          e.preventDefault();
          target = accordionButtons[accordionButtons.length - 1];
          break;
      }

      if (target) target.focus();
    });
  });

  function toggleAccordion(button) {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const contentId = button.getAttribute("aria-controls");
    const content = document.getElementById(contentId);

    button.setAttribute("aria-expanded", !isExpanded);
    content.hidden = !content.hidden;

    if (!isExpanded) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = null;
    }
  }
});
